import $ from 'jquery';
import '../vendors/slick';

if( $( "html" ).attr("dir") == "rtl" ) {
	var rtl = true;
} else {
	var rtl = false;
}

$( '.c-carousel-content__top' ).each( function ( key ) {
	const sliderIdName = 'slider' + key;
	const sliderNavIdName = 'sliderNav' + key;
	const sliderId = '#' + sliderIdName;
	const sliderNavId = '#' + sliderNavIdName;

	this.id = sliderIdName;
	$( '.c-carousel-content__bottom' )[ key ].id = sliderNavIdName;

	$( sliderId ).slick( {
		rtl: rtl,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		rows: 0,
		asNavFor: sliderNavId,
	} );

	$( sliderNavId ).slick( {
		rtl: rtl,
		slidesToShow: 4,
		slidesToScroll: 1,
		asNavFor: sliderId,
		focusOnSelect: true,
		rows: 0,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
				}
			},
		]
	} );
} );

if ( $( '.c-carousel-content__consent' ).length ) {
	$( document ).on( 'click', '.c-carousel-content__consent .c-button', function( e ) {
		e.preventDefault();
		$( this ).closest( '.c-carousel-content__consent' ).fadeOut( 200 );
	} );
}
